(function ($) {
    "use strict";

    $('body').on('click', '[data-toggle="delete"]', function (event) {
        event.preventDefault();
        var $this = $(this);
        if ($this.hasClass('disabled') || $this.prop('disabled')) {
            return false;
        }
        var frm = $(this).data('target');
        var msg = $(this).data('message');

        Swal.fire({
            title: 'Confirm',
            text: msg ? msg : 'Are you sure you want to delete this item?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                var $form = $(frm);
                if ($form.data('is-submitting')) {
                    return false;
                }
                var $btn = $form.find('button[type="submit"], input[type="submit"]');
                $btn.prop('disabled', true).addClass('disabled');
                return true;
            }
        }).then(function (result) {
            if (result.isConfirmed) {
                $(frm).submit();
            }
        });
    });
})($);
